import LogoTeal from "@/assets/LogoTeal.svg";
import UserBlack from "@/assets/UserBlack.png";
import CheckOut from "@/assets/check.svg";
import MenuBars from "@/assets/menuBars.svg";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
//import User from "../../../assets/user-gray.svg";
import { logoutUser } from "@/services/user";
import { RootState } from "@/store";
import { isBoardingProcessingStatue } from "@/types/employeeState";

interface NavbarProps {
  completeUI?: boolean;
}

const Navbar: React.FC<NavbarProps> = () => {
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const logoURL = window.partner ? window.partner?.logo : LogoTeal;

  const user = useSelector((state: RootState) => state.user);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getCodeFromURL = (): string | null => {
    const searchParams = new URLSearchParams(window.location.search);
    const standardCode = searchParams.get("code");
    if (standardCode) return standardCode;

    try {
      const hash = window.location.hash;
      const hashParams = new URLSearchParams(hash.split("?")[1] || "");
      return hashParams.get("code") || hashParams.get("employee");
    } catch {
      return null;
    }
  };

  const code = getCodeFromURL();

  const containerVariants = {
    hidden: { opacity: 0, transition: { when: "afterChildren" } },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
    exit: {
      opacity: 0,
      transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
  };

  const linkVariants = {
    hidden: { x: -10, opacity: 0 },
    visible: { x: 0, opacity: 1 },
    exit: { x: -10, opacity: 0 },
  };

  const shouldShowCompleteUI =
    pathname === "/" ||
    pathname === "/savings-settings" ||
    pathname.startsWith("/manage-account/");

  const isNotCreatePasswordPage = pathname !== "/create-password";

  const handleLogoClick = (e: React.MouseEvent) => {
    if (
      pathname === "/login" ||
      pathname === "/sep-introduction" ||
      pathname === "/create-password"
    ) {
      e.preventDefault();
    }
  };

  return (
    <>
      <nav className="bg-white z-[110] w-full  h-[var(--navigation-height)] shrink-0 flex items-center shadow">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <div className="flex items-center space-x-[32px]">
            <NavLink
              to={
                isBoardingProcessingStatue(user.onboardingProgress)
                  ? "/"
                  : "/wizard"
              }
              onClick={handleLogoClick}
            >
              <img
                src={logoURL}
                alt={window.partner?.title || "Sootchy"}
                className="h-[35px]"
              />
            </NavLink>

            {shouldShowCompleteUI && user && user.id && (
              <div className="hidden md:inline-flex space-x-1">
                <NavLink
                  to={`/?${searchParams}`}
                  className={({ isActive }) =>
                    `font-outfit leading-[127%] text-[16px] text-brand px-4 py-2 rounded-full transition-colors ${
                      isActive || pathname.startsWith("/manage-account/")
                        ? "bg-gray-100"
                        : "hover:bg-gray-100"
                    }`
                  }
                >
                  Accounts
                </NavLink>
                <NavLink
                  to="/savings-settings"
                  className={({ isActive }) =>
                    `font-outfit leading-[127%] text-[16px] text-default px-4 py-2 rounded-full transition-colors ${
                      isActive ? "bg-gray-100" : "hover:bg-gray-100"
                    }`
                  }
                >
                  Savings settings
                </NavLink>
              </div>
            )}
          </div>
          <div>
            <div className="hidden md:block">
              {user && user.id ? (
                <>
                  <div className="flex items-center space-x-[32px]">
                    <div className="flex space-x-2">
                      <img src={UserBlack} alt="User" />
                      <p className="font-outfit leading-[127%] text-[16px] text-default">
                        {user.username}
                      </p>
                    </div>
                    <button
                      data-testid="logout-user-button"
                      onClick={logoutUser}
                      className="flex items-center space-x-2"
                    >
                      <img src={CheckOut} alt="Log out" />
                      <p className="font-outfit leading-[127%] text-[16px] text-default">
                        Logout
                      </p>
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="hidden md:flex items-center space-x-[32px]">
                    {isNotCreatePasswordPage && (
                      <div className="flex space-x-2">
                        <NavLink
                          to={
                            code
                              ? `/sep-introduction?code=${code}`
                              : "/sep-introduction"
                          }
                          className={({ isActive }) =>
                            `font-outfit leading-[127%] text-[16px] text-default px-4 py-2 rounded-full transition-colors ${
                              isActive ? "bg-gray-100" : "hover:bg-[#e2e2e2]"
                            }`
                          }
                        >
                          What is this?
                        </NavLink>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>

            <div className="md:hidden">
              <div className="flex space-x-[12px]">
                {/*  <img src={user && user.id ? UserBlack : User} alt="Profile" /> */}
                <img
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  src={MenuBars}
                  alt="Menu"
                  className="cursor-pointer"
                />
              </div>

              <AnimatePresence>
                {isMenuOpen && (
                  <motion.div
                    key="menu"
                    initial="hidden"
                    animate="visible"
                    variants={containerVariants}
                    transition={{ duration: 0.1, delay: 0.1 }}
                    className={styles.openContainer}
                  >
                    <div className={`bg-white flex lg:hidden justify-between `}>
                      <NavLink to={"/"} onClick={handleLogoClick}>
                        <img
                          src={LogoTeal}
                          alt="Sootchy Logo"
                          className="h-[35px]"
                        />
                      </NavLink>

                      <div className="flex space-x-[12px]">
                        {/*  <div className="flex items-center">
                          <img
                            src={user && user.id ? UserBlack : User}
                            alt="Profile"
                          />
                        </div> */}
                        <div className="flex items-center">
                          <img
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            src={MenuBars}
                            alt="Menu"
                            className="cursor-pointer"
                          />
                        </div>
                      </div>
                    </div>

                    <h1 className={styles.navHeader}>Menu</h1>

                    {user && user.id ? (
                      <>
                        <div className="flex items-center space-x-2 py-[20px] border-b-2 border-[#F7F7F7]">
                          <img src={UserBlack} alt="User" />
                          <p className="font-outfit text-[20px]">
                            {user.username}
                          </p>
                        </div>
                        {shouldShowCompleteUI ? (
                          <>
                            <motion.ul variants={containerVariants}>
                              <motion.li
                                variants={linkVariants}
                                className={styles.navlinks}
                              >
                                <NavLink to={"/"}>Accounts</NavLink>
                              </motion.li>
                              <motion.li
                                variants={linkVariants}
                                className={styles.navlinks}
                              >
                                <NavLink to={"/savings-settings"}>
                                  Savings settings
                                </NavLink>
                              </motion.li>
                              <motion.li variants={linkVariants}>
                                <button
                                  data-testid="logout-user-button"
                                  onClick={logoutUser}
                                  className="py-[20px] cursor-pointer text-red-400 text-[20px]"
                                >
                                  Log out
                                </button>
                              </motion.li>
                            </motion.ul>
                          </>
                        ) : (
                          <>
                            <motion.ul variants={containerVariants}>
                              <motion.li variants={linkVariants}>
                                <button
                                  data-testid="logout-user-button"
                                  onClick={logoutUser}
                                  className="py-[20px] cursor-pointer text-red-400 text-[20px]"
                                >
                                  Log out
                                </button>
                              </motion.li>
                            </motion.ul>
                          </>
                        )}
                      </>
                    ) : (
                      <motion.ul variants={containerVariants}>
                        {isNotCreatePasswordPage && (
                          <motion.li
                            variants={linkVariants}
                            className={styles.navlinks}
                          >
                            <NavLink
                              to={
                                code
                                  ? `/sep-introduction?code=${code}`
                                  : "/sep-introduction"
                              }
                            >
                              What is this?{" "}
                            </NavLink>
                          </motion.li>
                        )}
                        {/* <motion.li
                          variants={linkVariants}
                          className={styles.navlinks}
                        >
                          <NavLink to={"/login"}>Login</NavLink>
                        </motion.li> */}
                      </motion.ul>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

const styles = {
  container:
    "fixed left-0 top-0 flex lg:hidden justify-between w-full p-[16px] ",
  openContainer:
    "bg-white w-full font-outfit h-screen p-[16px]  fixed lg:hidden left-0 top-0 select-none z-[200]",
  navlinks: "py-[20px] cursor-pointer border-b-2 border-[#F7F7F7] text-[20px]",
  navHeader: "pt-[56px] pb-[24px] text-[32px] font-semibold leading-[127%]",
};

export default Navbar;
